/**
 * @deprecated This file contains NSwag-generated models that are being replaced
 * by openapi-typescript generated types in `src/lib/query/nettbank.api.models.ts`.
 * These types are also most likely outdated, and they should not be updated.
 *
 * - For existing code: keep using these types, but do not modify or add new ones here. Refactoring away from these types is suggested.
 * - For new code: use apiClient for automatic correct type returns per route.
 * - Migration path: enable `<Nullable>enable</Nullable>` in the .csproj → re-run `pnpm gen:models` → refactor usages → delete this file once unused. *
 *
 * @see src/lib/query/nettbank.api.models.ts
 * @see src/lib/query/apiClient.ts
 */

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

/** @deprecated See file-level documentation */
export enum FormApplicationTypeEnum {
  None = 'None',
  PayoutRequestGrant = 'PayoutRequestGrant',
  PayoutRequestGrantSimple = 'PayoutRequestGrantSimple',
  FinalReportGrant = 'FinalReportGrant',
  PayoutRequestStartupLoan = 'PayoutRequestStartupLoan',
  PayoutRequestLoan = 'PayoutRequestLoan',
  CustomerUploadsRequiredDocumentation = 'CustomerUploadsRequiredDocumentation',
  AmortizationDelay = 'AmortizationDelay',
  DeMinimisAid = 'DeMinimisAid',
  DeferralPayment = 'DeferralPayment',
  GeneralApplicationAdditionalInformation = 'GeneralApplicationAdditionalInformation',
  InflowSelfDeclaration = 'InflowSelfDeclaration',
  GeneralApplicationPayoutRequest = 'GeneralApplicationPayoutRequest',
  ConferenceAttendance = 'ConferenceAttendance',
  ConferenceOrganizeAbroad = 'ConferenceOrganizeAbroad',
  ConferenceOrganizeIncoming = 'ConferenceOrganizeIncoming',
  GeneralApplicationAdditionalInformationPayoutRequest = 'GeneralApplicationAdditionalInformationPayoutRequest',
  Complaint = 'Complaint',
  ApplicationMaintenanceAmortizationDelay = 'ApplicationMaintenanceAmortizationDelay',
  PayoutRequestGrantOpusBioe = 'PayoutRequestGrantOpusBioe',
  PayoutRequestGrantOpusTrl = 'PayoutRequestGrantOpusTrl',
  PayoutRequestGrantOpusMatil = 'PayoutRequestGrantOpusMatil',
  PayoutRequestGrantConferenceAttendance = 'PayoutRequestGrantConferenceAttendance',
  InflowFillInInsuranceMovables = 'InflowFillInInsuranceMovables',
  PayoutRequestLoanShippingFishing = 'PayoutRequestLoanShippingFishing',
  ProjectAccounting = 'ProjectAccounting',
  PayoutRequestGrantHIP = 'PayoutRequestGrantHIP',
  ReleaseOfCollaterals = 'ReleaseOfCollaterals',
  MentorSupportPayout = 'MentorSupportPayout',
  MaintenanceAmendmentOfTerms = 'MaintenanceAmendmentOfTerms',
  MaintenancePriorityDeviation = 'MaintenancePriorityDeviation',
  FinalReportGrantSimple = 'FinalReportGrantSimple',
  DeMinimisAidV2 = 'DeMinimisAidV2',
  ApplicationGrantIncomeLoss = 'ApplicationGrantIncomeLoss',
  PayoutRequestGrantMatil = 'PayoutRequestGrantMatil',
}

/** @deprecated See file-level documentation */
export interface SubmittedFormListDto {
  id: string | undefined;
  applicationType: string | undefined;
  modifiedOn: string;
  title: string | undefined;
}

/** @deprecated See file-level documentation */
export interface SubmittedFormDto extends SubmittedFormListDto {
  attachments: IFormDataFile[] | undefined;
  submittedForm: SubmittedForm | undefined;
}

/** @deprecated See file-level documentation */
export interface IFormDataFile {
  contentType: string | undefined;
  uploadName: string | undefined;
  name: string | undefined;
  length: number;
  uploadTime: string;
}

/** @deprecated See file-level documentation */
export interface SubmittedForm {
  dataFieldName: string | undefined;
  title: string | undefined;
  formValues: SubmittedValue[] | undefined;
  submitter: Submitter | undefined;
  confirmations: string[] | undefined;
}

/** @deprecated See file-level documentation */
export interface SubmittedValue {
  name: string | undefined;
  displayName: string | undefined;
  value: string | undefined;
  displayValue: string | undefined;
  type: string | undefined;
  childValues: { [key: string]: SubmittedValue[] } | undefined;
}

/** @deprecated See file-level documentation */
export interface Submitter {
  name: string | undefined;
  roleNames: string | undefined;
  email: string | undefined;
  phone: string | undefined;
}

/** @deprecated See file-level documentation */
export interface BaseDocumentDao {
  _id: string | undefined;
  _type: string | undefined;
  _rev: string | undefined;
  _key: string | undefined;
  _createdAt: string | undefined;
  _updatedAt: string | undefined;
}

/** @deprecated See file-level documentation */
export interface AssetDao extends BaseDocumentDao {
  originalFileName: string | undefined;
  extension: string | undefined;
  mimeType: string | undefined;
  size: number;
  assetId: string | undefined;
  path: string | undefined;
  url: string | undefined;
}

/** @deprecated See file-level documentation */
export interface SubmittedFormResultDto {
  success: boolean;
  errors: string[] | undefined;
}

/** @deprecated See file-level documentation */
export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
  extensions: { [key: string]: any };

  [key: string]: any;
}

/** @deprecated See file-level documentation */
export interface ValidationResult {
  errorMessage: string | undefined;
  success: boolean;
  errorCode: string | undefined;
}

/** @deprecated See file-level documentation */
export interface ValidationResultOfFileErrorCodes extends ValidationResult {
  errorCode: FileErrorCodes;
}

/** @deprecated See file-level documentation */
export enum FileErrorCodes {
  None = 'None',
  NullInput = 'NullInput',
  FileTooBigError = 'FileTooBigError',
  FileNotCorrectType = 'FileNotCorrectType',
  FileError = 'FileError',
}

/** @deprecated See file-level documentation */
export interface FileMetaData {
  fileName: string | undefined;
  downloadName: string;
  fileType: string;
  contentType: string;
  fileSize: number;
}

/** @deprecated See file-level documentation */
export interface FileStreamHttpResult {
  contentType: string;
  fileDownloadName: string | undefined;
  lastModified: string | undefined;
  entityTag: EntityTagHeaderValue | undefined;
  enableRangeProcessing: boolean;
  fileLength: number | undefined;
  fileStream: Stream;
}

/** @deprecated See file-level documentation */
export interface EntityTagHeaderValue {
  tag: StringSegment;
  isWeak: boolean;
}

/** An optimized representation of a substring. */
/** @deprecated See file-level documentation */
export interface StringSegment {
  /** Gets the String buffer for this StringSegment. */
  buffer: string | undefined;
  /** Gets the offset within the buffer for this StringSegment. */
  offset: number;
  /** Gets the length of this StringSegment. */
  length: number;
  /** Gets the value of this segment as a String. */
  value: string | undefined;
  /** Gets whether this StringSegment contains a valid value. */
  hasValue: boolean;
}

/** @deprecated See file-level documentation */
export interface MarshalByRefObject {}

/** @deprecated See file-level documentation */
export interface Stream extends MarshalByRefObject {
  canTimeout: boolean;
  readTimeout: number;
  writeTimeout: number;
}

/** @deprecated See file-level documentation */
export interface AuthenticationResultDto {
  message: string | undefined;
  isAuthenticated: boolean;
}

/** @deprecated See file-level documentation */
export interface FormActionDto {
  applicationType: FormApplicationTypeEnum;
  actionType: FormActionTypeEnum;
  data: any | undefined;
}

/** @deprecated See file-level documentation */
export enum FormActionTypeEnum {
  AccountingSent = 'AccountingSent',
  AccountingUnavailable = 'AccountingUnavailable',
  CaseRedirect = 'CaseRedirect',
  CreateForm = 'CreateForm',
  OpenForm = 'OpenForm',
  OpusRedirect = 'OpusRedirect',
  ShowSubmitted = 'ShowSubmitted',
  PayoutPaidOut = 'PayoutPaidOut',
  PayoutDeadlinePassed = 'PayoutDeadlinePassed',
  PayoutUnavailable = 'PayoutUnavailable',
  PayoutSent = 'PayoutSent',
  FinalReportSent = 'FinalReportSent',
  FinalReportUnavailable = 'FinalReportUnavailable',
}

/** @deprecated See file-level documentation */
export enum BankAccountCategoryEnum {
  Unknown = 'Unknown',
  Loan = 'Loan',
  Grant = 'Grant',
  Guarantee = 'Guarantee',
  InterestSubsidy = 'InterestSubsidy',
  BackingGuarantee = 'BackingGuarantee',
}

/** @deprecated See file-level documentation */
export interface CustomerFormAction extends FormActionDto {
  disabled: boolean;
}

/** @deprecated See file-level documentation */
export interface FormApplicationTypeDto {
  formApplicationType: FormApplicationTypeEnum;
}

/** @deprecated See file-level documentation */
export interface DocumentDto {
  id: string;
  documentType: DocumentType;
  name: string | undefined;
  description: string | undefined;
  context: string | undefined;
  length: number;
  created: string;
  modified: string;
  customerHasRead: boolean;
  userHasRead: boolean;
}

/** @deprecated See file-level documentation */
export enum DocumentStatus {
  Unknown = 'Unknown',
  Draft = 'Draft',
  Published = 'Published',
  Deleted = 'Deleted',
}

/** @deprecated See file-level documentation */
export enum DocumentType {
  Unknown = 'Unknown',
  BankingAnnualStatement = 'BankingAnnualStatement',
  ApplicationDocument = 'ApplicationDocument',
  BankingInterestRateChangeDocument = 'BankingInterestRateChangeDocument',
  BankingDeferralPaymentDocument = 'BankingDeferralPaymentDocument',
  BankingWhatElseDocument = 'BankingWhatElseDocument',
}

/** @deprecated See file-level documentation */
export enum FileFormat {
  Unknown = 'Unknown',
  Pdf = 'Pdf',
}

/** @deprecated See file-level documentation */
export interface DocumentEventLogDto {
  id: string | undefined;
  created: string;
  modified: string;
  documentId: string | undefined;
  customerAccountId: string | undefined;
  userAccountId: string | undefined;
  eventType: EventType;
}

/** @deprecated See file-level documentation */
export enum EventType {
  Read = 'Read',
  Download = 'Download',
  Email = 'Email',
}

/** @deprecated See file-level documentation */
export interface DocumentGetOverviewResponse {
  documents: DocumentDtoWithProjectName[] | undefined;
  totalCount: number;
}

/** @deprecated See file-level documentation */
export interface DocumentDto2 {
  id: string | undefined;
  documentType: DocumentType;
  name: string | undefined;
  description: string | undefined;
  context: string | undefined;
  length: number;
  created: string;
  modified: string;
  customerHasRead: boolean;
  userHasRead: boolean;
}

/** @deprecated See file-level documentation */
export interface DocumentDtoWithProjectName extends DocumentDto2 {
  projectName: string | undefined;
}

/** @deprecated See file-level documentation */
export interface DocumentGetUnreadResponse {
  unreadCount: number;
}

/** @deprecated See file-level documentation */
export interface CaseDto {
  archiveCaseNo: string | undefined;
  projectName: string | undefined;
  accountName: string | undefined;
  decisionSystem: string | undefined;
  validationError: ValidationErrorEnum;
  status: ApplicationStatus | undefined;
  category: BankAccountCategoryEnum | undefined;
}

/** @deprecated See file-level documentation */
export enum ValidationErrorEnum {
  None = 'None',
  NotCorrectCompany = 'NotCorrectCompany',
}

/** @deprecated See file-level documentation */
export enum ApplicationStatus {
  Draft = 'Draft',
  MissingInformation = 'MissingInformation',
  Unallocated = 'Unallocated',
  UnderConsideration = 'UnderConsideration',
  PendingDecision = 'PendingDecision',
  AwaitingSignature = 'AwaitingSignature',
  Refusal = 'Refusal',
  Discarded = 'Discarded',
  Approved = 'Approved',
  ReturnedByMunicipality = 'ReturnedByMunicipality',
  UnallocatedMunicipality = 'UnallocatedMunicipality',
  UnderConsiderationMunicipality = 'UnderConsiderationMunicipality',
  RegistrationError = 'RegistrationError',
  Withdrawn = 'Withdrawn',
  Completed = 'Completed',
  Decided = 'Decided',
  Submitted = 'Submitted',
  Returned = 'Returned',
  AdmRefusal = 'AdmRefusal',
  UnderProcessing = 'UnderProcessing',
}

/** @deprecated See file-level documentation */
export interface CustomerTaskDto {
  id: string | undefined;
  active: boolean;
  status: string | undefined;
  type: CustomerTaskTypeEnum;
  title: string | undefined;
  message: string | undefined;
  created: string;
  data: any | undefined;
  applicationType: ApplicationTypeViewModel | undefined;
  decisionSystemApplicationType: ApplicationTypeViewModel | undefined;
}

/** @deprecated See file-level documentation */
export enum CustomerTaskTypeEnum {
  Unknown = 'Unknown',
  Application = 'Application',
  Inflow = 'Inflow',
  Forms = 'Forms',
  ConferenceGrant = 'ConferenceGrant',
}

/** @deprecated See file-level documentation */
export interface EntityBase {
  id: string;
}

/** @deprecated See file-level documentation */
export interface ApplicationTypeViewModel extends EntityBase {
  shortName: string | undefined;
  description: string | undefined;
  decisionSystem: string | undefined;
  allocationHelp: string | undefined;
  customerProjectAction: string | undefined;
  needId: string | undefined;
  needDescription: string | undefined;
  phaseId: string | undefined;
  phaseDescription: string | undefined;
  serviceId: string | undefined;
  serviceDescription: string | undefined;
  deliveryTypeId: string | undefined;
  deliveryTypeDescription: string | undefined;
  deliveryTagId: string | undefined;
  deliveryTagDescription: string | undefined;
  groupingId: string | undefined;
  groupingDescription: string | undefined;
  opusSortingValue: string | undefined;
  isActive: boolean;
  isAutoPayout: boolean;
}

/** @deprecated See file-level documentation */
export interface BankAccountOverviewSummaryDto {
  loans: BankAccountOverviewDto[] | undefined;
  guarantees: BankAccountOverviewDto[] | undefined;
  grants: BankAccountOverviewDto[] | undefined;
  interestSubsidies: BankAccountOverviewDto[] | undefined;
}

/** @deprecated See file-level documentation */
export interface BankAccountOverviewDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  category: BankAccountCategoryEnum;
  projectNo: string | undefined;
  amount: number;
  availableAmount: number;
  approveDate: string | undefined;
  lastTransactionDate: string | undefined;
  paymentAccountNumber: string | undefined;
  instrumentName: string | undefined;
  applicationType: ApplicationTypeViewModel | undefined;
  decisionSystemApplicationType: ApplicationTypeViewModel | undefined;
}

/** @deprecated See file-level documentation */
export enum BankAccountStatusEnum {
  Other = 'Other',
  Active = 'Active',
  Approved = 'Approved',
  Inactive = 'Inactive',
  Expired = 'Expired',
  InvoiceOverDue = 'InvoiceOverDue',
  DebtCollectionKredinor = 'DebtCollectionKredinor',
  Bankrupt = 'Bankrupt',
  PartiallyPaid = 'PartiallyPaid',
  Reset = 'Reset',
  WrittenOff = 'WrittenOff',
  DebtCollectionZolva = 'DebtCollectionZolva',
}

/** @deprecated See file-level documentation */
export interface GrantDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  projectNo: string | undefined;
  instrumentName: string | undefined;
  availableAmount: number | undefined;
  originalAmount: number | undefined;
  blockedAmount: number | undefined;
  bookBalance: number | undefined;
  approveDate: string;
  expiryDate: string;
  payoutDeadline: string | undefined;
}

/** @deprecated See file-level documentation */
export interface InterestSubsidyDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  typeCode: string | undefined;
  typeName: string | undefined;
  projectNo: string | undefined;
  instrumentName: string | undefined;
  totalAmount: number | undefined;
  availableAmount: number | undefined;
  payoutAmount: number | undefined;
  approveDate: string | undefined;
  matureDate: string | undefined;
  interestRate: number | undefined;
  nextPayoutDate: string | undefined;
  nextPayoutAmount: number | undefined;
}

/** @deprecated See file-level documentation */
export interface LoanOverviewViewModel {
  loanOverview: BankAccountOverviewDto | undefined;
  openInvoices: InvoiceDto[] | undefined;
}

/** @deprecated See file-level documentation */
export interface InvoiceDto {
  invoiceDate: string | undefined;
  amortizationAmount: number | undefined;
  customerIdentification: string | undefined;
  dueDate: string | undefined;
  originalDueDate: string | undefined;
  expensesAmount: number | undefined;
  feeDelayAmount: number | undefined;
  feeInvoiceAmount: number | undefined;
  interestAmount: number | undefined;
  invoiceNumber: number;
  lastPayDate: string | undefined;
  paidAmount: number | undefined;
  printPenaltyAmount: number | undefined;
  status: InvoiceStatusEnum;
  totalAmount: number | undefined;
  type: InvoiceTypeEnum;
  version: number | undefined;
}

/** @deprecated See file-level documentation */
export enum InvoiceStatusEnum {
  Undefined = 'Undefined',
  Due = 'Due',
  Pending = 'Pending',
  Overdue = 'Overdue',
  Replaced = 'Replaced',
  Reminder = 'Reminder',
  Default = 'Default',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  ZeroReminder = 'ZeroReminder',
  Preliminary = 'Preliminary',
  Composite = 'Composite',
  Terminate = 'Terminate',
  Postponed = 'Postponed',
  Loss = 'Loss',
  Transported = 'Transported',
  External = 'External',
  Cleared = 'Cleared',
}

/** @deprecated See file-level documentation */
export enum InvoiceTypeEnum {
  CommonMaster = 'CommonMaster',
  Ordinary = 'Ordinary',
  Reminder = 'Reminder',
  Termination = 'Termination',
  LeaseResidual = 'LeaseResidual',
  LeaseTermination = 'LeaseTermination',
  Credit = 'Credit',
  Repurchasor = 'Repurchasor',
  Undefined = 'Undefined',
  IndependentReminder = 'IndependentReminder',
  Zero = 'Zero',
  Detached = 'Detached',
  HirePurchaseActivation = 'HirePurchaseActivation',
  Factoring = 'Factoring',
  FactoringReminder = 'FactoringReminder',
  LeaseResidualReminder = 'LeaseResidualReminder',
  Correction = 'Correction',
  TerminationNote = 'TerminationNote',
  FactoringCredit = 'FactoringCredit',
  RemindLoanLoss = 'RemindLoanLoss',
  FactoringCommonReminder = 'FactoringCommonReminder',
  FactoringFee = 'FactoringFee',
  VatUpfront = 'VatUpfront',
}

/** @deprecated See file-level documentation */
export interface LoanDetailsViewModel {
  loanDetails: LoanDetailsDto | undefined;
  collaterals: CollateralDto[] | undefined;
}

/** @deprecated See file-level documentation */
export interface LoanDetailsDto {
  accountName: string | undefined;
  typeCode: string | undefined;
  stateCode: string | undefined;
  typeName: string | undefined;
  projectNo: string | undefined;
  instrumentName: string | undefined;
  totalAmount: number | undefined;
  availableAmount: number | undefined;
  payoutAmount: number | undefined;
  transferredLoanAmount: number | undefined;
  blockedAmount: number | undefined;
  bookBalance: number | undefined;
  approveDate: string | undefined;
  matureDate: string | undefined;
  interestRate: number | undefined;
  effectiveRate: number | undefined;
  payMethod: PaymentMethodEnum | undefined;
  periodMonths: number | undefined;
  periodFee: number | undefined;
  openFee: number | undefined;
  openFeePercent: number | undefined;
  interestType: InterestTypeEnum;
  fixedInterestExpiryDate: string | undefined;
  paymentAccountNumber: string | undefined;
  payoutDeadline: string | undefined;
}

/** @deprecated See file-level documentation */
export enum PaymentMethodEnum {
  Serial = 'Serial',
  Annuity = 'Annuity',
}

/** @deprecated See file-level documentation */
export enum InterestTypeEnum {
  NotSpecified = 'NotSpecified',
  Floating = 'Floating',
  Fixed = 'Fixed',
  Free = 'Free',
}

/** @deprecated See file-level documentation */
export interface CollateralDto {
  name: string | undefined;
  customerId: string | undefined;
  customerType: CustomerTypeEnum;
  type: CollateralTypeEnum;
}

/** @deprecated See file-level documentation */
export enum CustomerTypeEnum {
  Company = 'Company',
  Person = 'Person',
  Foreign = 'Foreign',
  Constellation = 'Constellation',
  InternalCostCenters = 'InternalCostCenters',
}

/** @deprecated See file-level documentation */
export enum CollateralTypeEnum {
  Debtor = 'Debtor',
  CoDebtor = 'CoDebtor',
  Guarantor = 'Guarantor',
  RealSurety = 'RealSurety',
}

/** @deprecated See file-level documentation */
export interface GuaranteeDetailsDto {
  status: BankAccountStatusEnum;
  accountName: string | undefined;
  projectNo: string | undefined;
  instrumentName: string | undefined;
  bookBalance: number | undefined;
  grossPrincipal: number | undefined;
  startDate: string | undefined;
  expiryDate: string | undefined;
  periodMonths: number | undefined;
  interestRate: number | undefined;
  openFee: number | undefined;
}

/** @deprecated See file-level documentation */
export interface PaymentPlanOverviewDto {
  previousPeriodRange: string | undefined;
  previousPeriodPlan: PaymentPlanEntryDto[] | undefined;
  currentPeriodRange: string | undefined;
  currentPeriodPlan: PaymentPlanEntryDto[] | undefined;
  yearRange: string | undefined;
  yearPlan: PaymentPlanEntryDto[] | undefined;
}

/** @deprecated See file-level documentation */
export interface PaymentPlanEntryDto {
  dueDate: string;
  interest: number;
  amortization: number;
  termFee: number;
  totalAmount: number;
  endBalance: number;
}

/** @deprecated See file-level documentation */
export interface TransactionOverviewDto {
  transactionDate: string | undefined;
  transactionCategory: TransactionCategoryEnum;
  amount: number | undefined;
  invoiceNumber: number | undefined;
}

/** @deprecated See file-level documentation */
export enum TransactionCategoryEnum {
  Other = 'Other',
  Transfer = 'Transfer',
  Payment = 'Payment',
  Blocking = 'Blocking',
  OpenFee = 'OpenFee',
  Refund = 'Refund',
  CommisionPayment = 'CommisionPayment',
  CommisionRefund = 'CommisionRefund',
  Transferred = 'Transferred',
}

/** @deprecated See file-level documentation */
export interface InvoicePdfDto {
  content: Stream | undefined;
}

/** @deprecated See file-level documentation */
export enum DocumentTypeEnum {
  TransactionDetails = 'TransactionDetails',
  PaymentPlan = 'PaymentPlan',
  SignedDocument = 'SignedDocument',
  SignedDocumentShippingFishing = 'SignedDocumentShippingFishing',
  OfferLetterDocument = 'OfferLetterDocument',
  SignedDocumentProjectAccounting = 'SignedDocumentProjectAccounting',
}

/** @deprecated See file-level documentation */
export interface ApplicationDto {
  id: string;
  sourceSystem: SourceSystem;
  decisionSystem: string | undefined;
  migrated: boolean;
  migratedFrom: string | undefined;
  projectName: string | undefined;
  bankAccountNumber: string | undefined;
  archiveCaseNo: string | undefined;
  status: ApplicationStatus;
  submittedOn: string;
  customerAccountId: string;
  decisionSystemId: string | undefined;
  dateSentToDecisionSystem: string | undefined;
  applicationType: ApplicationTypeViewModel | undefined;
  decisionSystemApplicationType: ApplicationTypeViewModel | undefined;
}

/** @deprecated See file-level documentation */
export enum SourceSystem {
  Master = 'Master',
  NatReg = 'NatReg',
  D365 = 'D365',
  Mds = 'Mds',
}

/** @deprecated See file-level documentation */
export interface TaskDto {
  flowId: string | undefined;
  taskId: string;
  taskCategory: string;
  taskType: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  processDefinitionId: string | undefined;
  status: string;
  context: any | undefined;
  data: any | undefined;
  attributes: any | undefined;
}

/** @deprecated See file-level documentation */
export interface FileParameter {
  data: any;
  fileName: string;
}
